import React from 'react';

export const ApiPage = () => {
    return (
        <div>
            RestApi Page
        </div>
    );
};